// TODO  - choose material colors closest to the absolute ones in this file

import getMuiTheme from 'material-ui/styles/getMuiTheme'
import {
  yellow900,
  grey100,
  grey300,
  grey400,
  grey500,
  white,
  darkBlack,
  fullBlack,
  green400,
} from 'material-ui/styles/colors'
import { fade } from 'material-ui/utils/colorManipulator'
import { merge } from 'lodash'

import { getTheme } from './selectors'
import content from '../content'

const defaultTheme = {
  fontFamily: 'Montserrat, sans-serif',
  appBar: {
    color: '#343e4b',
    height: 53,
    padding: 10,
    titleFontWeight: 700,
  },
  palette: {
    primary1Color: white,
    primary2Color: green400,
    primary3Color: grey400,
    accent1Color: yellow900,
    accent2Color: grey100,
    accent3Color: grey500,
    textColor: '#a0a7af',
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey300,
    disabledColor: fade(darkBlack, 0.3),
    pickerHeaderColor: '#143278',
    clockCircleColor: fade(darkBlack, 0.07),
    shadowColor: fullBlack,
  },
  tabs: {
    backgroundColor: white,
    selectedTextColor: '#2d3745',
    textColor: '#b6b8ba',
    padding: 0,
  },
  tabButton: {
    textTransform: 'none',
    fontWeight: 600,
    height: 34,
    margin: '0 20px',
  },
  inkBar: {
    backgroundColor: '#2d3745',
  },
  inkBarStyle: {
    marginTop: -3,
    height: 3,
    backgroundClip: 'content-box',
    padding: '0 20px',
  },
  textField: {
    backgroundColor: white,
  },
  raisedButton: {
    primaryColor: green400,
    style: {
      color: white,
      fontSize: 14,
      fontWeight: 700,
    },
  },
  chip: {
    textColor: '#ffffff',
  },
  drawer: {
    color: '#343e4b',
  },
  menuItem: {
    // TODO - add background and border
    selectedTextColor: white,
  },
  selectedMenuItemStyle: {
    backgroundColor: '#2b333d',
    borderLeft: `1px solid ${white}`,
  },
  menuItemStyle: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '32px',
    height: 32,
    minHeight: 32,
  },
  custom: {
    colors: {
      backgroundColor: '#f7f5f5',
      textInputBackgroundColor: white,
    },
    images: {
      logo: '',
    },
    metrics: {
      // base template padding
      basePadding: 10, // TODO: shouldn't depend on css files
      maxContentWidth: 600,
      tabNavigationHeight: 34,
      scheduleTimeRatio: 7 / 5, // pixels for 1 minute
    },
  },
}

const contentTheme = getTheme(content)

export const muiTheme = getMuiTheme(merge(defaultTheme, contentTheme))

console.log({ muiTheme })



// WEBPACK FOOTER //
// ./src/app/theme.js